import { borderRadiusValues } from './tokens';

export const borderRadius = {
    none: borderRadiusValues['radius-0'],
    xxs: borderRadiusValues['radius-2'],
    xs: borderRadiusValues['radius-4'],
    sm: borderRadiusValues['radius-6'],
    md: borderRadiusValues['radius-8'],
    lg: borderRadiusValues['radius-10'],
    xl: borderRadiusValues['radius-12'],
    '2xl': borderRadiusValues['radius-16'],
    '3xl': borderRadiusValues['radius-20'],
    '4xl': borderRadiusValues['radius-24'],
    '5xl': borderRadiusValues['radius-32'],
    full: borderRadiusValues['radius-full'],
} as const;
